import dataView from "./reducer";

export default dataView;
